module.exports = __webpack_public_path__ + "media/65.5c64c4a8.mp3";